import * as React from 'react';
import { createClient } from 'contentful';
import { ContentfulPreviewContext } from './PreviewContext.esm.js';

var createContentfulClient = function (clientParams) { return createClient(clientParams); };
var ContentfulClientConfigContext = React.createContext(null);
// for testing purposes only, used to mock a Contentful client
var ContentfulMockedClientContext = React.createContext({ client: null });
var useMemoClient = function (clientFactory) {
    var config = React.useContext(ContentfulClientConfigContext);
    var previewAPIContext = React.useContext(ContentfulPreviewContext);
    var testClient = React.useContext(ContentfulMockedClientContext).client;
    if (!testClient && (!config || Object.values(config).length < 3)) {
        throw Error("Missing Contentful client credentials testClient: ".concat(testClient, ", config: ").concat(JSON.stringify(config)));
    }
    var client = React.useMemo(function () {
        if (testClient)
            return testClient;
        if (!config) {
            throw Error("Missing Contentful client credentials config: ".concat(JSON.stringify(config)));
        }
        return clientFactory({
            accessToken: config.accessToken,
            environment: config.environment,
            host: (previewAPIContext === null || previewAPIContext === void 0 ? void 0 : previewAPIContext.shouldUsePreviewContext) ? 'preview.contentful.com' : undefined,
            space: config === null || config === void 0 ? void 0 : config.space,
        });
    }, [config, testClient, clientFactory, previewAPIContext === null || previewAPIContext === void 0 ? void 0 : previewAPIContext.shouldUsePreviewContext]);
    return client || testClient;
};
var useContentfulClient = function () {
    return useMemoClient(createContentfulClient);
};

export { ContentfulClientConfigContext, ContentfulMockedClientContext, createContentfulClient, useContentfulClient };
//# sourceMappingURL=client.esm.js.map
